const applyCommands = require("./applyCommands");
const { parseId } = require("./utils");
const deriveSimpleModel = require("./deriveSimpleModel");

const processCommands = commands => {
    let slideModel = {};
    return Object.keys(commands).sort().map(cmdId => {
        const cmd = commands[cmdId];
        const updates = JSON.parse(cmd.updates);
        slideModel = applyCommands(slideModel, updates);
        let { timestamp } = parseId(cmdId);
        let state = deriveSimpleModel(slideModel);
        return { state, timestamp, updates, cmd };
    });
};

const filterCommands = (commands, filter) => processCommands(commands).map(slide => slide.updates.filter(filter));

module.exports = { processCommands, filterCommands };
